module.exports = __webpack_public_path__ + "static/media/book1cover_preview.938a43e0.png";